/* ============================================================
   AUTO ATTIC — Theme JavaScript
   Features: YMM Search · VIN Decode · Cart · Mobile Nav
   ============================================================ */

(function () {
  'use strict';

  /* ----------------------------------------------------------
     YMM DATA
     Loaded from fitment-data.js (window.AA_FITMENT)
     Products tagged: fit-YEAR-MAKE-MODEL (normalized, lowercase)
     Search URL: /collections/all/fit-YEAR-MAKE-MODEL
  ---------------------------------------------------------- */
  function normalizeFitmentSlug(str) {
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  /* ----------------------------------------------------------
     SEARCH TAB SWITCHING
  ---------------------------------------------------------- */
  function initSearchTabs () {
    document.querySelectorAll('.search-box__tabs').forEach(function (tabBar) {
      tabBar.querySelectorAll('.search-tab').forEach(function (tab) {
        tab.addEventListener('click', function () {
          var box = tab.closest('.search-box');
          box.querySelectorAll('.search-tab').forEach(function (t) { t.classList.remove('is-active'); });
          box.querySelectorAll('.search-panel').forEach(function (p) { p.classList.remove('is-active'); });
          tab.classList.add('is-active');
          var target = tab.dataset.panel;
          var panel = box.querySelector('[data-panel-id="' + target + '"]');
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  /* ----------------------------------------------------------
     YMM DROPDOWNS — driven by fitment-data.js (window.AA_FITMENT)
  ---------------------------------------------------------- */
  function initYMMSearch () {
    var fitment = window.AA_FITMENT;
    if (!fitment) return; // fitment-data.js not loaded

    document.querySelectorAll('.ymm-form').forEach(function (form) {
      var yearSel  = form.querySelector('[data-ymm="year"]');
      var makeSel  = form.querySelector('[data-ymm="make"]');
      var modelSel = form.querySelector('[data-ymm="model"]');

      function clearSelect(sel, placeholder) {
        while (sel.options.length > 1) sel.remove(1);
        sel.options[0].text = placeholder;
      }

      function addOption(sel, value, text) {
        var opt = document.createElement('option');
        opt.value = value;
        opt.textContent = text;
        sel.appendChild(opt);
      }

      // Populate makes from fitment data
      if (makeSel) {
        fitment.makes.forEach(function (make) {
          addOption(makeSel, make, make);
        });
        makeSel.disabled = false;

        makeSel.addEventListener('change', function () {
          var selectedMake = makeSel.value;

          // Reset downstream
          clearSelect(modelSel, 'Select Model');
          clearSelect(yearSel, 'Select Year');
          modelSel.disabled = true;
          yearSel.disabled = true;

          if (!selectedMake) return;

          // Populate models for this make
          var models = fitment.models[selectedMake] || [];
          models.forEach(function (model) {
            addOption(modelSel, model, model);
          });
          modelSel.disabled = false;
        });
      }

      // When model changes, filter years to only those available for make+model
      if (modelSel) {
        modelSel.addEventListener('change', function () {
          var selectedMake  = makeSel ? makeSel.value : '';
          var selectedModel = modelSel.value;

          clearSelect(yearSel, 'Select Year');
          yearSel.disabled = true;

          if (!selectedMake || !selectedModel) return;

          var key   = selectedMake + '|' + selectedModel;
          var years = fitment.years[key] || [];
          years.forEach(function (year) {
            addOption(yearSel, year, year);
          });
          yearSel.disabled = false;
        });
      }

      // Form submit — build tag and redirect to collection filter
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var year  = yearSel  ? yearSel.value  : '';
        var make  = makeSel  ? makeSel.value  : '';
        var model = modelSel ? modelSel.value : '';

        if (!make) {
          alert('Please select a make.');
          return;
        }

        if (year && make && model) {
          // Full YMM: use tag-based collection filter for exact fitment match
          var tag = 'fit-' + normalizeFitmentSlug(year) + '-' + normalizeFitmentSlug(make) + '-' + normalizeFitmentSlug(model);
          window.location.href = '/collections/all/' + tag;
        } else if (make && model) {
          // Make + Model only: search across all years
          var q = make + ' ' + model;
          window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
        } else {
          // Make only: search by make
          window.location.href = '/search?type=product&q=' + encodeURIComponent(make);
        }
      });
    });
  }

  /* ----------------------------------------------------------
     VIN SEARCH (NHTSA Public API)
  ---------------------------------------------------------- */
  function initVINSearch () {
    document.querySelectorAll('.vin-form').forEach(function (form) {
      var input   = form.querySelector('.vin-input');
      var loading = form.querySelector('.vin-loading');
      var error   = form.querySelector('.vin-error');

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var vin = input ? input.value.trim().toUpperCase() : '';

        if (!vin || vin.length !== 17) {
          showVINError(error, 'Please enter a valid 17-character VIN.');
          return;
        }

        if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) {
          showVINError(error, 'VIN contains invalid characters. Please check and try again.');
          return;
        }

        hideVINMessages(loading, error);
        if (loading) loading.style.display = 'block';

        fetch('https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/' + vin + '?format=json')
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (loading) loading.style.display = 'none';
            var results = data.Results || [];
            var year  = getVINField(results, 'Model Year');
            var make  = getVINField(results, 'Make');
            var model = getVINField(results, 'Model');

            if (!year || !make) {
              showVINError(error, 'Could not decode this VIN. Please try a YMM search instead.');
              return;
            }
            if (year && make && model) {
              var tag = 'fit-' + normalizeFitmentSlug(year) + '-' + normalizeFitmentSlug(make) + '-' + normalizeFitmentSlug(model);
              window.location.href = '/collections/all/' + tag;
            } else {
              var q = [year, make, model].filter(Boolean).join(' ');
              window.location.href = '/search?type=product&q=' + encodeURIComponent(q);
            }
          })
          .catch(function () {
            if (loading) loading.style.display = 'none';
            showVINError(error, 'VIN lookup failed. Please check your connection and try again.');
          });
      });

      if (input) {
        input.addEventListener('input', function () {
          hideVINMessages(loading, error);
          input.value = input.value.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
        });
      }
    });
  }

  function getVINField (results, fieldName) {
    var match = results.find(function (r) { return r.Variable === fieldName; });
    return match && match.Value && match.Value !== 'null' && match.Value !== '0' ? match.Value : '';
  }

  function showVINError (el, msg) {
    if (el) { el.textContent = msg; el.style.display = 'block'; }
  }

  function hideVINMessages (loading, error) {
    if (loading) loading.style.display = 'none';
    if (error)   error.style.display   = 'none';
  }

  /* ----------------------------------------------------------
     MOBILE NAV
  ---------------------------------------------------------- */
  function initMobileNav () {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var nav    = document.querySelector('.mobile-nav');
    if (!toggle || !nav) return;
    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      toggle.textContent = isOpen ? '✕' : '☰';
    });
  }

  /* ----------------------------------------------------------
     ANNOUNCEMENT BAR CLOSE
  ---------------------------------------------------------- */
  function initAnnouncementBar () {
    var close = document.querySelector('.announcement-bar__close');
    var bar   = document.querySelector('.announcement-bar');
    if (!close || !bar) return;
    if (sessionStorage.getItem('aa-announcement-closed')) {
      bar.style.display = 'none';
      return;
    }
    close.addEventListener('click', function () {
      bar.style.display = 'none';
      sessionStorage.setItem('aa-announcement-closed', '1');
    });
  }

  /* ----------------------------------------------------------
     CART COUNT UPDATE
  ---------------------------------------------------------- */
  function updateCartCount () {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      })
      .catch(function () {});
  }

  /* ----------------------------------------------------------
     ADD TO CART
  ---------------------------------------------------------- */
  function initAddToCart () {
    document.querySelectorAll('.product-info__add-form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variantId = form.querySelector('[name="id"]');
        if (!variantId) return;
        var btn = form.querySelector('.btn-add-to-cart-main');
        if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId.value, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            if (btn) { btn.textContent = '✓ Added to Cart'; btn.disabled = false; }
            updateCartCount();
            setTimeout(function () {
              if (btn) btn.textContent = 'Add to Cart';
            }, 2500);
          })
          .catch(function () {
            if (btn) { btn.textContent = 'Error — Try Again'; btn.disabled = false; }
          });
      });
    });
  }

  /* ----------------------------------------------------------
     PRODUCT GALLERY THUMBNAILS
  ---------------------------------------------------------- */
  function initProductGallery () {
    document.querySelectorAll('.product-gallery').forEach(function (gallery) {
      var mainImg  = gallery.querySelector('.product-gallery__main img');
      var thumbs   = gallery.querySelectorAll('.product-gallery__thumb');
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
          if (mainImg) {
            mainImg.src = thumb.querySelector('img').src;
            mainImg.alt = thumb.querySelector('img').alt;
          }
        });
      });
    });
  }

  /* ----------------------------------------------------------
     COLLECTION SORT
  ---------------------------------------------------------- */
  function initCollectionSort () {
    var sortSel = document.querySelector('.collection-sort select');
    if (!sortSel) return;
    sortSel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }

  /* ----------------------------------------------------------
     INIT
  ---------------------------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initSearchTabs();
    initYMMSearch();
    initVINSearch();
    initMobileNav();
    initAnnouncementBar();
    initAddToCart();
    initProductGallery();
    initCollectionSort();
    updateCartCount();
  });

})();
